import { Page, withLazyErrorBoundary, } from '@office-start/office-home-app-shared';
import { convertRawPageToPageName } from '@office-start/telemetry-utility';
import React, { lazy } from 'react';
import { useParams } from 'react-router-dom';
import styles from './TemplatePage.module.scss';
var TemplatePageLazy = withLazyErrorBoundary(lazy(function () {
    return import(
    /* webpackChunkName: "templatepage" */ '@office-start/template-page-component');
}), 'TemplatePage');
export var TemplatePage = function () {
    var app = useParams().app;
    return (React.createElement(Page, { className: styles.templatePage, name: convertRawPageToPageName(app ? app + 'Templates' : 'VisioTemplates') },
        React.createElement(TemplatePageLazy, { configId: app ? app.toLowerCase() + 'Templates' : 'visioTemplates' })));
};
//# sourceMappingURL=TemplatePage.js.map